import $ from 'jquery';

const DATA_CONFIG = {
    PASSWORD_VALIDATION_PATH: '/umbraco/surface/SrtrAdmin/PasswordIsValid',
	CENTER_SELECT_PATH: '/umbraco/surface/SrtrAdmin/SwitchCenter',
    LIST_OF_CENTERS: '/umbraco/surface/SrtrAdmin/GetTransplantCenters',
    REPORTS_ACTIVITY: '/assets/data/reports_activity.json',
    TEST_VALIDATION_RESPONSE: '/assets/data/test_validation_response.json'
};

export default DATA_CONFIG;

$('.js-postLink').click(function(e) {
    if (this.href) {
    	var href = this.href;
    	var parts = href.split('?');
        var url = parts[0];
        var params = parts[1].split('&');
        var pp = '';
        var inputs = {};
        for(var i = 0, n = params.length; i < n; i++) {
            pp = params[i].split('=');
            inputs[pp[0]] = pp[1];
        }
        $.post(url, inputs)
        .done(location.reload());

        return false;
    }
});